import { createTheme } from '@mui/material/styles';

export const guyTheme = createTheme({
  palette: {
    primary: {
      main: '#4A7729',
      light: '#F8FAF7',
      dark: '#4A7729',
    },
    secondary: {
      main: '#4A7729',
      light: 'rgb(255 255 255/1)',
    },
    background: {
      default: '#F1F5EE',
      paper: '#F8FAF7',
    },
    star: {
      empty: '#808080',
      filled: '#e6d130',
    },
    FeeWrapper: {
      lightBlueWrapperBackground: 'rgb(235 245 255/1)',
      feeWrapperBackground: '#f0f9ee',
      feeWrapperLink: '#4caf50',
      feeWrapperText: '#3d3c3c',
    },
    Appointment: {
      AppointmentBackground: '#FFFEF7',
      AppointmentIcons: '#4caf50',
    },
    text: {
      primary: '#000000',
      secondary: '#008000',
      disabled: 'grey',
    },
    warning: {
      main: '#ffff00',
    },
    action: {
      disabled: '#9e9e9e',
    },
    AddressBumper: {
      editButton: '#006400',
    },
  },
  typography: {
    fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
    h1: {
      fontSize: '2.25rem',
      fontWeight: 700,
      marginBottom: '1.5rem',
      color: '#4A7729',
      textAlign: 'center',
    },
    h2: {
      fontSize: '1.875rem',
      fontWeight: 700,
      color: '#4A7729',
      marginBottom: '1.5rem',
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 700,
      marginBottom: '1rem',
      color: '#4A7729',
    },
    h4: {
      fontSize: '1rem',
      fontWeight: 'bold',
      color: '#000000',
      textAlign: 'left',
      marginTop: '1em',
      marginBottom: '1em',
    },
    h6: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      color: '#000000',
    },
    caption: {
      fontSize: '0.8rem',
      fontWeight: 'bold',
      color: '#008000',
      textAlign: 'left',
    },

    body1: {
      fontSize: '0.8rem',
      color: '#000000',
      arrowIconColor: 'rgb(255 255 255/1)', //for arrow in button
      priceQuoteBackground: '#F8FAF7',
      ndrpSectionBackground: '#f9fafa',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          backgroundColor: '#4A7729',
          '&:hover': {
            backgroundColor: '#294117',
          },
          '&:disabled': {
            backgroundColor: 'rgb(249 250 251/1)',
            borderColor: 'rgb(229 231 235/1)',
            color: 'rgb(209 213 219/1)',
          },
          color: 'white',
        },
      },
    },
    MuiList: {
      styleOverrides: {
        root: {
          color: 'rgb(55 65 81)',
          fill: '#4A7729',
          backgroundColor: '#F8FAF7',
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          color: '#4A7729',
          '&:hover': {
            color: '#4A7729',
          },
          width: '1.5rem',
          height: '1.5rem',
          '&.Mui-disabled': {
            color: '#9e9e9e',
          },
        },
      },
    },
    MuiInputLabel: {
      styleOverrides: {
        root: {
          fontWeight: 600,
          color: 'rgb(17 24 39 / 1)',
          fontSize: '1rem',
        },
      },
    },
    MuiInput: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          fontFamily: 'Inter, system-ui, Avenir, Helvetica, Arial, sans-serif',
        },
      },
    },
  },
});
